import { withErrorBoundary } from "@edreamsodigeo/frontend-core";

import PrimeDatalayerTracking from "~/components/tracking";
import withPrimeContext from "../withPrimeContext";

export default withPrimeContext(
  withErrorBoundary(PrimeDatalayerTracking, { name: "PrimeDatalayerTracking" }),
);
